/**
 *
 * This Class represents the attributes of the user
 *
 */

export class Activity {
    private id: String;
    private text: String;
    private name: String;
    private createdAT;

    /**
     * Constructor of activity object
     * @param id ID of activity
     */
    constructor(id: String) {
        this.id = id;
    }

    /**
    * This function set the id
    * @param id id of activity
    */
    public setId(id: String): void {
        this.id = id;
    }

    /**
     * This function get the id
     * @return id of study
     */
    public getId(): String {
        return this.id;
    }

    /** ------------------------ */

    /**
     * This function set the text
     * @param text text of activity
     */
    public setText(text: String): void {
        this.text = text;
    }

    /**
     * This function get the text
     * @return text of activity
     */
    public getText(): String {
        return this.text;
    }

    /** ------------------------ */

    /**
     * This function set the name
     * @param name name of activity
     */
    public setName(name: String): void {
        this.name = name;
    }

    /**
     * This function get the name
     * @return name of activity
     */
    public getName(): String {
        return this.name;
    }

    /** ------------------------ */

    /**
     * This function set the createdAt
     * @param createdAt createdAtof activity
     */
    public setCreatedAt(createdAT): void {
        this.createdAT = createdAT;
    }

    /**
     * This function get the createdAt
     * @return createdAt of activity
     */
    public getCreatedAt() {
        return this.createdAT;
    }


}


// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/models/activity.ts